import React, {useState, useEffect} from 'react';
import {Button} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

export default function ModalConfirm({ showModal, hideModal, confirmModal, item }) {
  return (
    <Modal show={showModal} fullscreen={'md-down'} onHide={hideModal}>
      <Modal.Header closeButton>
        <Modal.Title>Alert</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to delete?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={hideModal}>
          Close
        </Button>
        <Button variant="primary" onClick={() => confirmModal(item)}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
